import "./src/styles/global.css"
import webVitals from "./src/utils/web-vitals"

webVitals()